import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { BereichsQuerySorterConfig } from 'fa-kt.types';
import { BereichsService } from '../service';

@Component({
  selector: 'fa-kt-bereichs-sorter',
  templateUrl: './bereichs-sorter.component.html',
  styleUrls: ['./bereichs-sorter.component.css'],
})
export class BereichsSorterComponent {
  BereichsSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public bereichs: BereichsService,
  ) {
    this.BereichsSorterConfig = BereichsQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
